import colors from "./colors";

export const theme = {
  colors,
};
